"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LilVRGDA__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "int256",
                name: "_targetPrice",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "_priceDecayPercent",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "_perTimeUnit",
                type: "int256",
            },
            {
                internalType: "address",
                name: "_wethAddress",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "ADDRESS_ZERO",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "INVALID_UPGRADE",
        type: "error",
    },
    {
        inputs: [],
        name: "ONLY_CALL",
        type: "error",
    },
    {
        inputs: [],
        name: "ONLY_DELEGATECALL",
        type: "error",
    },
    {
        inputs: [],
        name: "ONLY_PROXY",
        type: "error",
    },
    {
        inputs: [],
        name: "ONLY_UUPS",
        type: "error",
    },
    {
        inputs: [],
        name: "UNSUPPORTED_UUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "reservePrice",
                type: "uint256",
            },
        ],
        name: "AuctionReservePriceUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "winner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AuctionSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "interval",
                type: "uint256",
            },
        ],
        name: "AuctionUpdateIntervalUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "poolSize",
                type: "uint256",
            },
        ],
        name: "PoolSizeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "expectedBlockNumber",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expectedNounId",
                type: "uint256",
            },
        ],
        name: "buyNow",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchNextNoun",
        outputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
            {
                internalType: "string",
                name: "svg",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "fetchNoun",
        outputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "accessory",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                ],
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
            {
                internalType: "string",
                name: "svg",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentVRGDAPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSeederBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "sold",
                type: "int256",
            },
        ],
        name: "getTargetSaleTime",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "timeSinceStart",
                type: "int256",
            },
            {
                internalType: "uint256",
                name: "sold",
                type: "uint256",
            },
        ],
        name: "getVRGDAPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_nextNounId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_poolSize",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_nounsSoldAtAuction",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_nounsTokenAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_nounsSeederAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_nounsDescriptorAddress",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lilNounderRewardNouns",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextNounId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nextNounIdForCaller",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsDAORewardNouns",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsDescriptor",
        outputs: [
            {
                internalType: "contract INounsDescriptorV2",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsSeeder",
        outputs: [
            {
                internalType: "contract INounsSeederV2",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsSoldAtAuction",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsToken",
        outputs: [
            {
                internalType: "contract INounsToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "poolSize",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reservePrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "seederBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_poolSize",
                type: "uint256",
            },
        ],
        name: "setPoolSize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
        ],
        name: "setReservePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_updateInterval",
                type: "uint256",
            },
        ],
        name: "setUpdateInterval",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "startTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "targetPrice",
        outputs: [
            {
                internalType: "int256",
                name: "",
                type: "int256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "updateInterval",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newImpl",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newImpl",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "usedBlockNumbers",
        outputs: [
            {
                internalType: "bool",
                name: "used",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wethAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class LilVRGDA__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_targetPrice, _priceDecayPercent, _perTimeUnit, _wethAddress, overrides) {
        return super.deploy(_targetPrice, _priceDecayPercent, _perTimeUnit, _wethAddress, overrides || {});
    }
    getDeployTransaction(_targetPrice, _priceDecayPercent, _perTimeUnit, _wethAddress, overrides) {
        return super.getDeployTransaction(_targetPrice, _priceDecayPercent, _perTimeUnit, _wethAddress, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.LilVRGDA__factory = LilVRGDA__factory;
LilVRGDA__factory.bytecode = _bytecode;
LilVRGDA__factory.abi = _abi;
